<template lang="pug">
  main
    NavBarInventario
    ModalDelete(v-show="modalStatusDel" :title="titleModalDel" :content="contentModalDel" @padre:eliminar="deleteItem")
    ModalInfo(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:close="cerrarModal")
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading && !ocultarFormAltas")
      .container
        .columns
          .column.is-full.has-text-centered
            h3.title Datos Generales de Alta {{ $route.params.id }}
              |  
              router-link.a.button.is-default.is-rounded.is-medium(to="/Inventario/Altas/")
                i.fas.fa-times
        .columns
          .column.is-one-quarter
            .field
              label.label Ubicación
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="alta.ubicacion" :disabled="isDisabled")
                    option(value="") Selecciona la Ubicación
                    option(value="GIA") GIA
                    option(value="TPA") TPA
                    option(value="IRGE") IRGE
                    option(value="ERM") ERM-TLAUTLA
                    option(value="EB00") EB00
                    option(value="EB01") EB01
                    option(value="EB02") EB02
                    option(value="EB03") EB03
                    option(value="EB04") EB04
                .icon.is-small.is-left
                  i.fas.fa-map-pin
            .field
              label.label Solicita
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="alta.solicita" :disabled="isDisabled")
                    option(value="" checked) Seleccione un Usuario
                    option(v-for="data in usuarios_Solicita" :value="data.id" :key="data.id") {{ data.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-user-tag
            .field
              label.label Autoriza
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="alta.autoriza" :disabled="isDisabled")
                    option(value="" checked) Seleccione un Usuario
                    option(v-for="data in usuarios_Autoriza" :value="data.id" :key="data.id") {{ data.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-user-check
            a.button.is-warning.is-rounded.is-medium(@click="editAlta" v-show="!isEditing") Editar
            | &nbsp
            a.button.is-default.is-rounded.is-medium(@click="cancelEditAlta" v-show="isEditing") Cancelar
            | &nbsp
            a.button.is-primary.is-rounded.is-medium(@click="updateAlta" v-show="isEditing") Actualizar
            a.button.is-black.is-rounded.is-medium(@click="printAlta" v-show="!isEditing")
              i.fas.fa-print
          .column.is-three-quarters
            a.button.is-success.is-rounded.is-small(@click="addArt" v-show="!isAddingArt")
              | Agregar Item &nbsp
              i.fas.fa-plus
            | &nbsp
            FormArticulo(v-show="isAddingArt" @finishEdit="finalizarEdicion" @closeArticulo="cerrarArticulo" @itemSaved="hayNewItem" :alta="alta" :itemEdit="itemToEdit")
            ListArticulos(v-show="!isAddingArt" :idAlta="this.$route.params.id" :actualizarComp="actualizarList" @itemToDelete="eliminarItem" @itemToEdit="editarItem" @listaActualizada="listadoActualizado")
</template>

<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import usuariosServices from '../../services/usuarios/usuarios'
import ModalInfo from '@/components/shared/ModalInfo.vue'
import ModalDelete from '@/components/shared/ModalDelete.vue'
import FormArticulo from '@/components/inventario_Componentes/FormArticulo.vue'
import ListArticulos from '@/components/inventario_Componentes/ListArticulos.vue'
import moment from 'moment'

export default {
  name: 'AltaDetalle',
  components: { Loader, NavBarInventario, ModalInfo, FormArticulo, ListArticulos, ModalDelete },
  data () {
    return {
      isLoading: true,
      alta: {
        id: '',
        ubicacion: '',
        area: '',
        id_usuario: '',
        usuario: '',
        solicita: '',
        nombreSolicita: '',
        autoriza: '',
        nombreAutoriza: '',
        fechaReg:''
      },
      usuarios_Solicita: [],
      usuarios_Autoriza: [],
      isDisabled: true,
      isEditing: false,
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      modalStatusDel: false,
      contentModalDel: '',
      titleModalDel: '',
      isAddingArt: false,
      ocultarFormAltas: false,
      idAlta: '',
      tipos: [],
      actualizarList: false,
      itemToDelete: {},
      itemToEdit: {}
    }
  },
  methods: {
    obtenerDatosAlta () {
      this.idAlta = this.$route.params.id
      
      InventarioServices.getAltaInd(this.idAlta)
        .then(res => {
          let alta = res[0]
          setTimeout(() => {
            this.alta.id = alta.id
            this.alta.ubicacion = alta.ubicacion
            this.alta.area = alta.area
            this.alta.id_usuario = alta.id_usuario
            this.alta.usuario = alta.usuario
            this.alta.solicita = alta.id_Solicita
            this.alta.nombreSolicita = alta.solicita
            this.alta.autoriza = alta.id_Autoriza
            this.alta.nombreAutoriza = alta.autoriza
            this.alta.area = alta.area
            this.alta.fechaReg = alta.fechaReg
            
            

            this.isLoading = false
          }, 2000);
        })
    },

    obtenerDataTipos () {
      InventarioServices.getTipos()
        .then(res => {
          console.log(res)
          if (res.length > 0) {
              this.tipos = res
          } else {
            console.log('No hay Tipos')
          }
        })
    },

    obtenerUsuarios () {
      usuariosServices.getUsuarios()
        .then(res => {
          console.log(res)
          if (res.length > 0) {
              let uSolicita = res.filter(user => user.categoria === '3')
              let uAutoriza = res.filter(user => user.categoria === '2' || user.categoria === '1')
              this.usuarios_Solicita = uSolicita
              this.usuarios_Autoriza = uAutoriza
            } else {
              this.titleModal = 'Erro'
              this.contentModal = res.respuesta
              this.modalStatus = true
            }
        })
    },

    updateAlta () {
      this.isEditing = false
      this.isDisabled = true
      this.isLoading = true      

      let nombreSolicita = this.usuarios_Solicita.find( user => user.id === this.alta.solicita );
      let nombreAutoriza = this.usuarios_Autoriza.find( user => user.id === this.alta.autoriza );

      this.alta.nombreSolicita = nombreSolicita.nombre
      this.alta.nombreAutoriza = nombreAutoriza.nombre

      InventarioServices.editAlta(this.$route.params.id, this.alta.ubicacion, this.alta.solicita, this.alta.nombreSolicita, this.alta.autoriza, this.alta.nombreAutoriza, this.alta.area, this.alta.ordenCompra, this.alta.tipo)
        .then(res => {
          console.log(res)
          if (res.success) {

            setTimeout(() => {
              this.isEditing = false
              this.isDisabled = true  
              this.isLoading = false
            }, 2000);

          } else {
            this.isLoading = false

          }
        })
    },

    editAlta () {
      this.isDisabled = false
      this.isEditing = true
    },

    cancelEditAlta () {
      this.isDisabled = true
      this.isEditing = false
    },

    addArt () {
      this.isAddingArt = true
      // this.ocultarFormAltas = true
    },

    cerrarGrupo () {
      this.isAddingGroup = false
      this.ocultarFormAltas = false
    },

    cerrarArticulo () {
      this.isAddingArt = false
    },

    cerrarModal () {
      this.modalStatus = false
    },

    hayNewItem () {
      this.actualizarList = true
    },

    eliminarItem (item) {
      console.log(item)
      if (item) {
        this.itemToDelete = item
        this.titleModalDel = 'Eliminar.'
        this.contentModalDel = `¿Seguro desea eliminar ${item.serie} | ${item.marca} - ${item.modelo}?`
        this.modalStatusDel = true
      }
    },

    editarItem (item) {
      console.log(item)
      if (item) {
        this.itemToEdit = item
        this.isAddingArt = true
      }
    },
    deleteItem (result) {
      console.log(result)
      this.modalStatusDel = false
      if (result === 'delete') { 
        this.isLoading = true
        InventarioServices.deleteItem(this.itemToDelete.id)
          .then(data => {
            console.log(data)
            this.isLoading = true
            if (data.success){

              setTimeout(() => {
              this.isLoading = false
              this.actualizarList = true              
              this.titleModal = 'Item Eliminado'
              this.contentModal = `El Item ${this.itemToDelete.serie} | ${this.itemToDelete.marca} - ${this.itemToDelete.modelo} se ha Eliminado con Éxito.`
              this.modalStatus = true
              this.isLoading = false
              }, 1000);
            } else {
              setTimeout(() => {
                this.titleModal = 'Error.'
                this.contentModal = data.respuesta
                this.modalStatus = true
                this.isLoading = false
              }, 1000);
            }
          })
      } else {

      }
    },

    finalizarEdicion (finalizar) {
      if (finalizar) {
        this.itemToEdit = {}
      } 
    },
    
    listadoActualizado (result) {
      this.actualizarList = false
    },
    
    printAlta () {
      let currentUrl = window.location.hostname
      let firma = 'C:/xampp/htdocs/image/firma1.png'
      let tipo = 'pdf'
      let link
      console.log(currentUrl)
      if (currentUrl === 'http://201.132.87.234') {
        link = `http://201.132.87.234/servidores/reporteAlta.php?id=${this.idAlta}&fSolicita=${firma}&fAutoriza=${firma}&tipo=${tipo}`
      } else {
        link = `http://10.121.50.145/servidores/reporteAlta.php?id=${this.idAlta}&fSolicita=${firma}&fAutoriza=${firma}&tipo=${tipo}`
      }
      console.log(link)
      
      if (open(link)) {
        console.log('Abriendo archivo')
      }
    }

  },
  created () {
    this.obtenerUsuarios()
    this.obtenerDatosAlta()
    this.obtenerDataTipos()
  }
}
</script>

<style lang="scss" scoped>
  .section {
    padding-top: 1rem;
    padding-bottom: 0px;
  }
</style>





// WEBPACK FOOTER //
// src/components/inventario_Componentes/AltaDetalle.vue